// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
};
// export const url = 'https://staging.lojanteka.com';
// export const url = "https://lojanteka.com";
export const url = "https://admin.lojanteka.com";
export const backendUrl = `${url}/api/`;
export const imageUrl = `${url}/public/upload/item/`;
export const secretKey = 'Loja Nteka'
export const pagesWithTabs = [
  '/dashboard',
  '/seller',
  '/saved-list',
  '/messages',
  '/account',
  '/seller/my-shop',
  '/my-orders',
];

export enum ProductCondition {
  New,
  SemiNew,
}
export const firebaseConfig = {
  apiKey: "AIzaSyBiIsRWNjJHj44A0lFGakkonUkOrc4V5FQ",
  authDomain: "lojanteka-app.firebaseapp.com",
  databaseURL: "https://lojanteka-app-default-rtdb.firebaseio.com",
  projectId: "lojanteka-app",
  storageBucket: "lojanteka-app.appspot.com",
  messagingSenderId: "391061322091",
  appId: "1:391061322091:web:0e74635d404678b378342e",
  measurementId: "G-F311MKCCQ1"
};
export const currencyCode = 'AOA ';
export const chatUrl = 'https://lojanteka-app-default-rtdb.firebaseio.com/';
export const termsUrl = 'https://lojanteka.com/terms-services/';
export const privacyUrl = 'https://lojanteka.com/privacy-policy/';
export const googleMapApiKey = "AIzaSyB0cMmnD8eTpLHdREritcHCU8LpFFHhllk"


export const angolaProvince = [
  {
    "name": "Bengo",
    "code": "AO-BGO",
    "municipos": [
      { name: 'Ambriz' },
      { name: 'Bula Atumba' },
      { name: 'Dande' },
      { name: 'Nambuangongo' },
      { name: 'Pango ' },
    ]
  },
  {
    "name": "Benguela",
    "code": "AO-BGU",
    "municipos": [
      { name: 'Balombo' },
      { name: 'Baía Farta' },
      { name: 'Benguela' },
      { name: 'Bocoio' },
      { name: 'Caimbambo' },
      { name: 'Catumbela' },
      { name: 'Chongoroi' },
      { name: 'Cubal' },
      { name: 'Ganda' },
      { name: 'Lobito' },
    ]
  },
  {
    "name": "Bié",
    "code": "AO-BIE",
    "municipos": [
      { name: 'Andulo' },
      { name: 'Camacupa' },
      { name: 'Catabola' },
      { name: 'Chinguar' },
      { name: 'Chitembo' },
      { name: 'Cuemba' },
      { name: 'Cunhinga' },
      { name: 'Cuíto' },
      { name: 'Nharea' },
    ]
  },
  {
    "name": "Cabinda",
    "code": "AO-CAB",
    "municipos": [
      { name: 'Belize' },
      { name: 'Buco-Zau' },
      { name: 'Cabinda' },
      { name: 'Cacongo' },
    ]
  },
  {
    "name": "Cunene",
    "code": "AO-CNN",
    "municipos": [
      { name: 'Cahama' },
      { name: 'Cuanhama' },
      { name: 'Curoca' },
      { name: 'Cuvelay' },
      { name: 'Namacunde' },
      { name: 'Ombadja' },
    ]
  },
  {
    "name": "Huambo",
    "code": "AO-HUA",
    "municipos": [
      { name: 'Bailundo' },
      { name: 'Catchiungo' },
      { name: 'Caála' },
      { name: 'Ekunha' },
      { name: 'Huambo' },
      { name: 'Londuimbale' },
      { name: 'Longongo' },
      { name: 'Mungo' },
      { name: 'Tchicala-Tcholoanga' },
      { name: 'Tchindjenje' },
      { name: 'Ucuma' },
    ]
  },
  {
    "name": "Huíla",
    "code": "AO-HUI",
    "municipos": [
      { name: 'Caconda' },
      { name: 'Cacula' },
      { name: 'Caluquembe' },
      { name: 'Chiange' },
      { name: 'Chibia' },
      { name: 'Chicomba' },
      { name: 'Chipindo' },
      { name: 'Humpata' },
      { name: 'Jamba' },
      { name: 'Kuvango' },
      { name: 'Lubango' },
      { name: 'Matala' },
      { name: 'Quilengues' },
      { name: 'Quipungo' },
    ]
  },
  {
    "name": "Kuando Kubango",
    "code": "AO-CCU",
    "municipos": [
      { name: 'Calai' },
      { name: 'Cuangar' },
      { name: 'Cuchi' },
      { name: 'Cuito Cuanavale' },
      { name: 'Dirico' },
      { name: 'Longa' },
      { name: 'Mavinga' },
      { name: 'Menongue' },
      { name: 'Rivungo' },
    ]
  },
  {
    "name": "Kwanza Norte",
    "code": "AO-CNO",
    "municipos": [
      { name: 'Ambaca' },
      { name: 'Banga' },
      { name: 'Bolongongo' },
      { name: 'Cambambe' },
      { name: 'Cazengo' },
      { name: 'Golungo Alto' },
      { name: 'Gonguembo' },
      { name: 'Lucala' },
      { name: 'Quiculungo' },
      { name: 'Samba Caju' },
    ]
  },
  {
    "name": "Kwanza Sul",
    "code": "AO-CUS",
    "municipos": [
      { name: 'Amboim' },
      { name: 'Cassongue' },
      { name: 'Bolongongo' },
      { name: 'Conda' },
      { name: 'Ebo' },
      { name: 'Libolo' },
      { name: 'Mussende' },
      { name: 'Porto Amboim' },
      { name: 'Quibala' },
      { name: 'Quilenda' },
      { name: 'Seles' },
      { name: 'Sumbe' },
      { name: 'Waku Kungo' },
    ]
  },
  {
    "name": "Luanda",
    "code": "AO-LUA",
    "municipos": [
      { name: 'Belas' },
      { name: 'Cacuaco' },
      { name: 'Cazenga' },
      { name: 'Icolo e Bengo' },
      { name: 'Luanda' },
      { name: 'Quiçama' },
      { name: 'Kilamba Kiaxi' },
      { name: 'Talatona' },
      { name: 'Viana' },
    ]
  },
  {
    "name": "Lunda Norte",
    "code": "AO-LNO",
    "municipos": [
      { name: 'Cambulo' },
      { name: 'Capenda-Camulemba' },
      { name: 'Caungula' },
      { name: 'Chitato (Tchitato)' },
      { name: 'Cuango' },
      { name: 'Cuilo' },
      { name: 'Lóvua' },
      { name: 'Lubalo' },
      { name: 'Lucapa' },
      { name: 'Xá Muteba' },
    ]
  },
  {
    "name": "Lunda Sul",
    "code": "AO-LSU",
    "municipos": [
      { name: 'Cacolo' },
      { name: 'Dala' },
      { name: 'Muconda' },
      { name: 'Saurimo' },
    ]
  },
  {
    "name": "Malange",
    "code": "AO-MAL",
    "municipos": [
      { name: 'Cacuso' },
      { name: 'Calandula' },
      { name: 'Cambundi-Catembo' },
      { name: 'Cangandala' },
      { name: 'Caombo' },
      { name: 'Cuaba Nzogo' },
      { name: 'Cunda-Diaza' },
      { name: 'Luquembo' },
      { name: 'Malange' },
      { name: 'Marimba' },
      { name: 'Massango' },
      { name: 'Caculama-Mucari' },
      { name: 'Quela' },
      { name: 'Quirima' },
    ]
  },
  {
    "name": "Moxico",
    "code": "AO-MOX",
    "municipos": [
      { name: 'Alto Zambeze' },
      { name: 'Bundas' },
      { name: 'Camanongue' },
      { name: 'Cameia' },
      { name: 'Luau' },
      { name: 'Lucano' },
      { name: 'Luchazes' },
      { name: 'Léua' },
      { name: 'Moxico' },
    ]
  },
  {
    "name": "Namibe",
    "code": "AO-NAM",
    "municipos": [
      { name: 'Bibala' },
      { name: 'Camulo' },
      { name: 'Namibe' },
      { name: 'Tômbua' },
      { name: 'Virei' },
    ]
  },
  {
    "name": "Uíge",
    "code": "AO-UIG",
    "municipos": [
      { name: 'Alto Cauale' },
      { name: 'Ambuíla' },
      { name: 'Bembe' },
      { name: 'Buengas' },
      { name: 'Bungo' },
      { name: 'Damba' },
      { name: 'Macocola' },
      { name: 'Maquela do Zombo' },
      { name: 'Mucaba' },
      { name: 'Negage' },
      { name: 'Puri' },
      { name: 'Quimbele' },
      { name: 'Quitexe' },
      { name: 'Sanza Pombo' },
      { name: 'Uíge' },
    ]
  },
  {
    "name": "Zaire",
    "code": "AO-ZAI",
    "municipos": [
      { name: 'Cuimba' },
      { name: 'M`Banza Kongo' },
      { name: 'Noqui' },
      { name: 'N`Zeto' },
      { name: 'Soyo' },
      { name: 'Tomboco' },
    ]
  }
]

// AIzaSyCtYlRPNyRpmEy8v6hCMTtcVwcbD-q6bKs
// export enum OrderStatus {
//   pending,
//   confirm,
//   delivered,
//   decline,
//   return
// }
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
